import { RegisterEffect } from './register.effect';

export const TransactionRegisterEffects = [RegisterEffect];
